import React from 'react';

import {SearchItemsSelectSingle} from 'app/search/components/SearchItemsSelect';
import {gt} from 'app/utils/i18n';

import type {SearchSerializedType} from 'sweet-types';

interface Props {
  selected: SearchSerializedType | null;
  queryParams?: {content_type: string; object_id: number | string};
  disabled?: boolean;
  onChange: (item: SearchSerializedType | null) => Promise<unknown>;
}

export function TasksFilterbarTargetObject({
  selected,
  queryParams,
  disabled,
  onChange,
}: Props): JSX.Element {
  return (
    <SearchItemsSelectSingle
      selectProps={{
        autoFocus: true,
      }}
      disabled={disabled}
      placeholder={gt('Filter by procedures or processes...')}
      params={{
        ct: 'procedure,proceduregroup',
        ordering: 'name',
      }}
      lazyFetch={true}
      selected={selected}
      queryParams={queryParams}
      onChange={onChange}
    />
  );
}
